export const Members = [
  {
    group: 'bantu',
    members: [
      {
        name: 'Chingalo, Eric',
        nickName: 'Megamind',
        imageUrl: 'chingalo.png',
        links: [
          'echingalo@gmail.com',
          '255683397035',
          'eric.chingalo',
          'ericchingalo',
          'eric-chingalo-711630185/',
        ],
      },
      {
        name: 'Mduda, Elias',
        nickName: 'Root',
        imageUrl: 'mduda.png',
        links: ['eliusmduda@gmail.com', '255692096797', '', 'EliusMduda', ''],
      },
    ],
  },
  {
    group: 'Trench',
    members: [
      {
        name: 'Kedyson, Kelvin',
        nickName: 'Master',
        imageUrl: 'kedyson.png',
        links: [
          'kelvinkedysonzacharia@gmail.com',
          '255744345000',
          'kelvin.kedyson',
          '',
          'kelvin-kedyson-0b76b6180',
        ],
      },
      {
        name: 'Makwesheni, K',
        nickName: 'Maquiz',
        imageUrl: 'marquiz.png',
        links: [
          'jkedmon95@gmail.com',
          '255675580888',
          'kedmon.maquiz',
          'KedmonMaquiz',
          'kedmon-maquiz-9429061a9',
        ],
      },
      {
        name: 'Mushi, D N',
        nickName: 'Don',
        imageUrl: 'don.png',
        links: [
          'donnicholaus@gmail.com',
          '255743313344',
          '',
          'DonNicholaus',
          'donbosco-mushi-707609193',
        ],
      },
    ],
  },
  {
    group: 'Wanaa',
    members: [
      {
        name: 'Mwajungwa, M L',
        nickName: 'Mike',
        imageUrl: 'mwajungwa.png',
        links: [
          'michaellugano8@gmail.com',
          '255742613453',
          'michael.mwajungwa.1',
          'MichaelLugano1',
          '',
        ],
      },
      {
        name: 'Sengoli, Yohana',
        nickName: 'Yoo',
        imageUrl: 'sengoli.png',
        links: ['sengoliyhn@gmail.com', '255654159216', '', '', ''],
      },
      {
        name: 'Mawi, Baraka',
        nickName: 'Mawio',
        imageUrl: 'mawi.png',
        links: [
          'barakamawi@gmail.com ',
          '255753219376',
          'donbaraka.vanmawi',
          '',
          '',
        ],
      },
      {
        name: 'Rayman, G M',
        nickName: 'Ryan',
        imageUrl: 'rayman.png',
        links: ['iamrayman2018@outlook.com', '255746195907', '', '', ''],
      },
      {
        name: 'Emmily, Remmy',
        nickName: 'Enemy',
        imageUrl: 'remmy.png',
        links: [
          'remmyemmily98@gmail.com ',
          '255626334115 ',
          '',
          'RemmyEmmily',
          'remmy-emmily-7779481a2',
        ],
      },
      {
        name: 'Kalebo W',
        nickName: 'Mwamba',
        imageUrl: 'kalebu.png',
        links: ['kalebmabutwa@gmail.com', '', '', '', ''],
      },
      {
        name: 'Moyo, P',
        nickName: 'THeart',
        imageUrl: 'moyo.png',
        links: ['poisentm@gmail.com', '', '', '', ''],
      },
      {
        name: 'Undefined',
        nickName: 'Noctunal',
        imageUrl: 'undefined.png',
        links: ['', '', '', '', ''],
      },
    ],
  },
];
